/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import { Tooltip, IconButton, Menu, MenuItem } from "@mui/material";
import { menuSlotProps, moreIconButtonSxProps } from "../../../helpers";
import { useStoreDispatch } from "../../../../store/hooks";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { setBasicDialogOpenFor, setOpenToast } from "../../../../store/helpers/helperReducers";
import { useThresholdCrossingSettingRuleData } from "./hooks";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { IThresholdCrossingSettingRule } from "../../../../store/api/admin/types"
import { useState } from "react";
import { setThresholdCrossingSettingRuleModelOpenMode, setSelectedThresholdCrossingSettingRule } from "../../../../store/api/admin/reducers";

interface IProfileRuleActionMenuProps {
  tableRow: any;
  disableDelete?: boolean;
}

const ProfileRuleActionMenu: React.FC<IProfileRuleActionMenuProps> = ({ tableRow, disableDelete }) => {
  const dispatch = useStoreDispatch();

  const {
    anchorElThresholdCrossingSettingRule,
    setAnchorElThresholdCrossingSettingRule,
    deleteThresholdCrossingSettingRuleHandler
  } = useThresholdCrossingSettingRuleData(tableRow?.row);

  const openMenuThresholdCrossingSettingRule = Boolean(anchorElThresholdCrossingSettingRule);
  const handleOnMoreIconThresholdCrossingSettingRuleClick = (event: React.MouseEvent<HTMLButtonElement>, selectedRow: any) => {
    setAnchorElThresholdCrossingSettingRule(event.currentTarget);
    dispatch(setSelectedThresholdCrossingSettingRule(selectedRow.row));
  };

  const addThresholdCrossingSettingRuleHandler = () => {
    dispatch(setThresholdCrossingSettingRuleModelOpenMode("Add"));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.THRESHOLDCROSSINGSETTINGRULE));
  };

  const editThresholdCrossingSettingRuleHandler = () => {
    dispatch(setThresholdCrossingSettingRuleModelOpenMode("Edit"));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.THRESHOLDCROSSINGSETTINGRULE));
  };

  const handlePopup = (type: string) => {
    setAnchorElThresholdCrossingSettingRule(null);
    if (type === "Edit") {
      return editThresholdCrossingSettingRuleHandler();
    } else if (type === "Delete") {
      if (disableDelete) {
        dispatch(
          setOpenToast({
            openToast: true,
            toastType: "error",
            message: "You can not delete this rule. At least one rule is required.",
          })
        );
      }
      else {
        return deleteThresholdCrossingSettingRuleHandler();
      }
    } else {
      return addThresholdCrossingSettingRuleHandler();
    }
  };

  return (
    <>
      <Tooltip title="" arrow>
        <IconButton
          sx={moreIconButtonSxProps}
          aria-label="more"
          id="threshold-crossing-setting-rule"
          aria-controls={openMenuThresholdCrossingSettingRule ? "threshold-crossing-setting-rule-menu" : undefined}
          aria-expanded={openMenuThresholdCrossingSettingRule ? "true" : undefined}
          aria-haspopup="true"
          onClick={(event) => handleOnMoreIconThresholdCrossingSettingRuleClick(event, tableRow)}
        // disabled={isEnableMoreIcon}
        >
          <MoreVertIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <Menu
        id="threshold-crossing-setting-rule-menu"
        anchorEl={anchorElThresholdCrossingSettingRule}
        open={openMenuThresholdCrossingSettingRule}
        onClose={() => setAnchorElThresholdCrossingSettingRule(null)}
        MenuListProps={{
          "aria-labelledby": "threshold-crossing-setting-rule",
          className: "p-0",
          sx: { py: 0 , width: "110px"}
        }}
        PaperProps={{
          className: "rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
          elevation: 0
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
       >
        <MenuItem onClick={() => handlePopup("Edit")}  style={{paddingLeft:8, minHeight: "26px"}} className="relative flex cursor-default select-none items-center gap-4 rounded-sm px-2 py-0.5 text-[11px] outline-none transition-colors hover:!bg-muted hover:!text-foreground hover:rounded">
          <EditIcon sx={{ fontSize: 15 }} className="text-foreground" />
           <span style={{ fontSize: 15 }} > Edit </span>
        </MenuItem>
        <MenuItem
          onClick={() => handlePopup("Delete")}
          style={{paddingLeft:8, height: "26px"}}
          className={`group relative flex cursor-default select-none items-center gap-4 rounded-sm px-2 py-0.5 text-[11px] outline-none transition-colors ${disableDelete ? "text-destructive opacity-50" : "text-destructive hover:!bg-muted hover:!text-foreground hover:rounded"}`}
        >
          <DeleteIcon sx={{ fontSize: 15 }} className={disableDelete ? "text-destructive" : "text-destructive group-hover:!text-foreground"} />
          <span style={{ fontSize: 15 }} className={disableDelete ? "text-destructive" : "text-destructive group-hover:!text-foreground"}>Delete</span>
        </MenuItem>
      </Menu>
    </>
  );
};


export default ProfileRuleActionMenu;
